<template>
  <v-main class="fondo-app">
    <v-container fill-height>
      <v-row align="center" justify="center">
        <v-card
          ref="tarjeta"
          width="400"
          class="py-6 px-10 text-center"
          elevation="4"
          style="margin-top: -20px; min-width: 300px"
          :disabled="bloquearFormulario"
        >
          <div class="logo-cliente-login" style="width: 100%;"></div>
          <div class="mt-8 text-h6" style="color: #31708f">Recuperar contraseña</div>
          <v-text-field
            ref="inputCorreoElectronico"
            class="mt-1"
            label="Correo electrónico"
            prepend-inner-icon="mdi-email"
            :rules="[rules.required]"
            v-model="email"
            type="email"
            spellcheck="false"
            @blur="completarEmail"
          ></v-text-field>
          <v-btn
            class="mt-2"
            block
            large
            color="primary"
            elevation="2"
            :disabled="!datosRellenos"
            @click="recuperarContrasena"
          >Recuperar</v-btn>
          <div class="mt-5">
            <router-link to="/">
              <a>Iniciar sesión</a>
            </router-link>
          </div>
        </v-card>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import api from "@/api";
import {deshabilitarAutocompletado} from "@/util";

export default {
  data: () => ({
    rules: {
      required: (value) => !!value || "Requerido",
    },
    email: "",
    bloquearFormulario: false,
  }),
  methods: {
    completarEmail() {
      if (this.email != "" && !this.email.includes("@"))
        this.email = this.email + "@" + this.$parametros_configuracion.domcorelepordef;
    },
    recuperarContrasena() {
      this.bloquearFormulario = true;
      api.recuperarContrasena(this.email)
        .finally (() => {
          this.$cuadroDeDialogo.mostrar ('Recuperación de contraseña', 'Se ha enviado un email de recuperación de contraseña al correo electrónico indicado.', ['Aceptar'])
            .finally (() => {
              this.$router.replace ('/');
            });
          this.bloquearFormulario = false;
        });
    },
  },
  computed: {
    datosRellenos() {
      return this.email != "";
    },
  },
  mounted() {
    deshabilitarAutocompletado (this.$refs["tarjeta"].$el);
    this.$refs["inputCorreoElectronico"].focus();
  },
};
</script>

<style>
</style>